import { css } from '@emotion/core'
import React, { type ReactNode } from 'react'

// TODO it would be better if @fs/zion-person had a way to align children with the person text.

const indentCss = ({
  avatarSize,
  gutters,
}: {
  avatarSize: 24 | 40
  gutters: 'xxs' | 'xs'
}): ReturnType<typeof css> => css`
  margin-inline-start: calc(${avatarSize}px + var(--spacer-${gutters}));
`

type Props = {
  children: ReactNode
  avatarSize?: 24 | 40
  gutters?: 'xxs' | 'xs'
}

/** Person component's text alignment decorator -- defaults to 24px avatarSize and xxs gutters */
export default function PersonTextAlignmentDecorator({ children, avatarSize, gutters }: Props): JSX.Element {
  return <div css={indentCss({ avatarSize: avatarSize ?? 24, gutters: gutters ?? 'xxs' })}>{children}</div>
}
